<template>
  <div>
    <h4>Bitácora de siniestro</h4>
    <div class="md-layout">
      <BinnacleEntriesExtranet
        ref="binnacle-timeline"
        :submitting="submitting"
        :entries="extranetBinnacleEntries"
        :taggableUsers="taggableUsers"
        @update:newComment="addComment"
        reverse
        :show-new-comment-input="$canView('Sinister', 'extranetbinnacle')"
        :add-new-comment-input="$canAdd('Sinister', 'extranetbinnacle')"
      />
    </div>
  </div>
</template>

<script>
import extranetService from "@/services/extranet";
import { BinnacleEntriesExtranet } from "@/components";
import { mapState } from "vuex";
import { adaptBinnacleEntries } from "../RoadSinisters/File/utils";

export default {
  name: "ExtranetBinnacle",
  components: { BinnacleEntriesExtranet },
  props: {
    affectedId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      comments: [],
      submitting: false,
      taggableUsers: [],
    };
  },
  computed: {
    ...mapState(["account"]),
    extranetBinnacleEntries() {
      return adaptBinnacleEntries(this.comments);
    },
  },
  methods: {
    fetchBinnacle() {
      return Promise.all([
        extranetService.fetchBinnacle(this.affectedId),
        extranetService.fetchTaggableUsers(),
      ]).then((res) => {
        this.comments = res[0];
        this.taggableUsers = res[1];
      });
    },
    addComment(comment, mentionedUsers = []) {
      const newEntry = {
        user: `${this.account.firstName} ${this.account.lastName}`,
        note: comment,
        type: "info",
        mentionedUsers,
      };
      this.submitting = true;
      extranetService
        .sendBinnacle(newEntry, this.affectedId)
        .then((newComment) => {
          this.comments.push(newComment);
          this.$refs["binnacle-timeline"].reset();
        })
        .finally(() => (this.submitting = false));
    },
  },
  watch: {
    affectedId: {
      immediate: true,
      handler: "fetchBinnacle",
    },
  },
};
</script>

<style lang="scss" scoped>
.md-layout {
  display: flex;
  width: 150%;
  transform: translate(10%, 0%);
}
</style>



// WEBPACK FOOTER //
// src/pages/extranet/Binnacle.vue